import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Upload, message } from "antd";
import Webcam from "react-webcam";
import { CameraOutlined, UploadOutlined } from "@ant-design/icons";

const MultipleImageUploadWithOneRemark = ({ refDocs = [], ImageUpload }) => {
  const [isModalVisible, setIsModalVisible] = useState(false); // Modal visibility state
  const [capturedImages, setCapturedImages] = useState([]); // To store captured images
  const [remark, setRemark] = useState(""); // Remark for all images
  const [isMobile, setIsMobile] = useState(false); // To check if the device is mobile
  const [webcamKey,setWebCamKey]=useState(0)
  const webcamRef = useRef(null); // Webcam reference

  // useEffect(()=>{
  //   setCapturedImages(refDocs)
  // },[refDocs])


  // useEffect(()=>{
  //   ImageUpload(capturedImages)
  // },[capturedImages])
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  // Open Modal
  const showModal = () => {
    setIsModalVisible(true);
    setWebCamKey((prevKey) => prevKey + 1); // Force remount by updating the key
  };

  // Close Modal
  const handleCancel = () => {
    setIsModalVisible(false);
    handleCloseCamera()
  };

  // Capture Image from Webcam (for Desktop)
  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      fetch(imageSrc)
        .then((res) => res.blob())
        .then(
          (blob) => {
            const newFile = new File([blob], `webcam_image_${new Date().getTime()}.png`, { type: "image/png" })
            ImageUpload([...refDocs, newFile])
          })
        .catch((err) => {
          console.log(err, "Error when capture image");
        })
      // Add the captured image to the list
    }
  };

  // Handle mobile camera capture or storage upload
  const handleCaptureImage = (event) => {
    const file = event.file || event.target.files[0];
    if (file.status !== "removed") {
      ImageUpload([...refDocs, file])
    }
  };

  // Handle remark change
  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  // Handle Upload
  const handleUpload = async () => {
    const formData = new FormData();

    // Convert each captured image (data URL) to a file and append to FormData
    const imageBlobs = await Promise.all(
      capturedImages.map((image, index) =>
        fetch(image)
          .then((res) => res.blob())
          .then(
            (blob) =>
              new File([blob], `webcam_image_${index}.png`, { type: "image/png" })
          )
      )
    );

    imageBlobs.forEach((file) => formData.append("files", file));
    formData.append("remark", remark);

    // Example upload (pass to parent component or call your API)
    ImageUpload(imageBlobs);

    // Close modal after upload
    setIsModalVisible(false);
    setCapturedImages([]); // Reset images
    setRemark(""); // Reset remark
  };


  const handleRemove = (file) => {
    // Filter out the file to remove it from the list
    const updatedFileList = refDocs.filter((item) => item.uid !== file.uid);
    ImageUpload(updatedFileList)
    // setCapturedImages(updatedFileList);
  };

  const handleCloseCamera = () => {
    // Stop the webcam stream
    if (webcamRef.current?.video?.srcObject) {
      const stream = webcamRef.current.video.srcObject;
      const tracks = stream.getTracks(); // Get all tracks (audio/video)
      tracks.forEach((track) => track.stop()); // Stop each track
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      {/* Button to open the modal */}
      <Button type="primary" onClick={showModal}>
        {isMobile ? "Add Images" : "Add Images"}
      </Button>

      {/* Ant Design Modal for Webcam and Upload */}
      <Modal
        // width={'30%'}
        title={isMobile ? "Mobile Image Upload" : "Capture Images using Webcam"}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={() => { handleCancel(); setCapturedImages([]); handleCloseCamera() }}>
            Cancel
          </Button>,
          <Button key="upload" type="primary" onClick={handleCancel}>
            Save
          </Button>,
        ]}
      >
        {/* For Desktop/Laptop: Webcam Section */}
        {!isMobile && (
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
           {isModalVisible &&  <Webcam
              key={webcamKey}
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/png"
              width={'80%'}
              height={300}
            />}
            <Button
              type="default"
              onClick={captureImage}
              style={{ marginTop: "10px", marginLeft: '4px' }}
            >
              Capture Image
            </Button>
            {/* Upload from storage */}
            <Upload
              fileList={refDocs}
              beforeUpload={() => false} // Prevent immediate upload
              accept="image/*"
              listType="picture"
              maxCount={5} // Limit the number of images

              onChange={(info) => handleCaptureImage(info)}
              onRemove={handleRemove}
            >
              <Button icon={<UploadOutlined />}>Upload from Storage</Button>
            </Upload>
          </div>
        )}

        {/* For Mobile: Mobile Camera Capture or Storage Upload */}
        {isMobile && (
          <div style={{ display: "flex", justifyContent: "space-around", marginBottom: "20px" }}>
            {/* Mobile Camera Capture */}
            <input
              type="file"
              accept="image/*"
              capture="camera"
              onChange={handleCaptureImage}
              style={{ display: "none" }}
              id="mobile-camera-input"
            />
            <Button
              icon={<CameraOutlined />}
              onClick={() => document.getElementById("mobile-camera-input").click()}
            >
              Capture from Camera
            </Button>

            {/* Upload from storage */}
            <Upload
              beforeUpload={() => false} // Prevent immediate upload
              accept="image/*"
              listType="picture"
              maxCount={5} // Limit the number of images
              onChange={(info) => handleCaptureImage(info)}
            >
              <Button icon={<UploadOutlined />}>Upload from Storage</Button>
            </Upload>
          </div>
        )}

        {/* Preview Captured Images */}
        {/* {capturedImages.length > 0 && (
          <div>
            <h4>Captured/Selected Images:</h4>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              {capturedImages.map((image, index) => (
                <img
                  key={index}
                  src={URL.createObjectURL(image)}
                  alt={`Captured ${index}`}
                  style={{ width: "100px", height: "75px", border: "1px solid #ccc" }}
                />
              ))}
            </div>
          </div>
        )} */}

        {/* Remark Input */}
        <div style={{ marginTop: "20px" }}>
          <input
            type="text"
            placeholder="Enter remark for all images"
            value={remark}
            onChange={handleRemarkChange}
            style={{ padding: "5px", width: "100%" }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default MultipleImageUploadWithOneRemark;
